<script>
  import * as configs from 'legacy/modules/common/components/MNumericInput/MNumericInputConfigurations';
  import formatNumber from 'legacy/modules/common/components/MNumeric/formatNumber';

  export default {
    name: 'FormatNumberMixin',
    props: {
      type: {
        type: String,
        default: 'integer',
        choices: Object.keys(configs)
      },
      minimumValue: {
        type: [Number, String],
        default: null
      },
      maximumValue: {
        type: [Number, String],
        default: null
      },
      symbol: {
        type: [String, Boolean],
        default: null
      },
      negative: {
        type: Boolean,
        default: null
      },
      allowDecimalPadding: {
        type: Boolean,
        default: null
      },
      decimalPlaces: {
        type: Number,
        default: 2
      },
      minWithVat: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        localMinimumValue: this.minimumValue
      };
    },
    watch: {
      minimumValue () {
        this.initOptions();
      }
    },
    mounted () {
      this.initOptions();
    },
    methods: {
      initOptions () {
        if (this.minWithVat && this?.vat && this.minimumValue && this?.removeVat) {
          this.localMinimumValue = this.removeVat(this.minimumValue);
        } else {
          this.localMinimumValue = this.minimumValue;
        }
      },
      getFormattedNumber (
        number, {withCurrencySymbol = true, type = undefined, shortenNumber = false, shortenDecimalPlaces = 1} = {}
      ) {
        return formatNumber(number, type || this.type, {
          minimumValue: this.localMinimumValue,
          maximumValue: this.maximumValue,
          symbol: this.symbol,
          negative: this.negative,
          allowDecimalPadding: this.allowDecimalPadding,
          decimalPlaces: this.decimalPlaces,
          withCurrencySymbol,
          shortenNumber,
          shortenDecimalPlaces
        });
      }
    }
  };
</script>
